<template>
  <nav>
    <div class="navbar-header">
        <!-- Branding Image -->
        <a class="navbar-brand" href="/">
            DePlitzviner Scrapbook
        </a>
    </div>
    <div class="rightside">
      <AdminHeader v-if="user" />
      <slot />
    </div>
  </nav>
</template>

<script>

import AdminHeader from "@/components/layout/AdminHeader.vue";

export default {
  name: 'layout-header',
  components: {
    AdminHeader
  },
  computed: {
    user () {
      return this.$cookie.get('key')
    }
  },
  mounted () {
    console.log(this.$cookie)
  }
}
</script>

<style lang="scss" scoped>
  nav {
    display: flex;
    justify-content: space-between;
    padding: 5px 20px;
  }
  .navbar-brand {
    color: $brandWhite;
    text-decoration: none;
    
  }
  .rightside {
    display: flex;
    justify-content: flex-end;

  }
  .rightside > div {
    margin-left: 10px;
  }
</style>
